import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function usuarioComboReducer(state= initialState.usuarioCombo, action){
	switch(action.type){
		case types.GET_USUARIOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}